export default {"src":"/_next/static/media/reload_24.4d7d0619.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};